import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { Button } from '../tornado/button/button.component';
import { getInitialStyle } from './userInfoBar.style';
import { t } from '../i18n';
import Avatar from '../tornado/avatar/avatar.component';
import { CHANGE_PROFILE_SIGNAL } from '../user/account/account.constants';

export default class UserInfoBar extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Content: {
          Avatar: {
            type: Avatar,
          },
          Name: {},
          ProfileChangeButton: {
            type: Button,
            label: t('profile.switch'),
          },
        },
      },
      getInitialStyle(),
    );
  }

  set photoId(value) {
    this.tag('Avatar').photoId = value;
  }

  set userName(value) {
    this.tag('Name').text.text = value;
  }

  _getFocused() {
    return this.tag('ProfileChangeButton');
  }

  _handleEnter() {
    this.signal(CHANGE_PROFILE_SIGNAL);
  }
}
